export default __webpack_public_path__ + "static/media/bacqueville7.af17dca6.jpg";